import type { AxiosResponse } from "axios";
import { createQuery } from "react-query-kit";

import type { IInviteToken } from "@api/videoVisit/types";
import type { ID } from "@constants";
import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient, AxiosError } from "@/api";

const key = "invite-guest";

type IResponse = AxiosResponse<IApiResponse<IInviteToken>>;
interface IVariables {
  appointmentId: ID;
}

export const getInviteToken: IAxiosFn<IVariables, IResponse> = async (
  params,
  signal,
) => {
  return axiosClient.get(`video-visit/${params?.appointmentId}/invite`, {
    params,
    signal,
  });
};

export const useInviteToken = createQuery<IResponse, IVariables, AxiosError>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getInviteToken(variables, signal),
  retry(_failureCount, error) {
    return error.code !== AxiosError.ERR_BAD_REQUEST;
  },
});
